import {ContactPage} from './ContactPage';
export default ContactPage;
